import styled, { css } from 'styled-components';
import { textOverflow } from 'helpers/styles.js';
import { StyledComponentContainer, StyledTabContainer, StyledTab } from '@bit/knotchinc.web-react-components.tabs';

/* General Styles */
export const StyledOverviewContainer = styled.div`
  margin-bottom: ${({ mb }) => mb};
  ${StyledComponentContainer} {
    box-shadow: 0px 3px 10px 2px rgba(0,0,0,0.06);
    border-radius: 5px;
  }
  ${StyledTabContainer} {
    box-shadow: -6px 5px 10px -4px rgba(0,0,0,0.06);
  }
  ${StyledTab} {
    box-shadow: 0px -3px 10px -2px rgba(0,0,0,0.06);
  }
`;

export const ContentContainer = styled.div`
  margin-left: 20px;
  padding: ${({ padding }) => padding || '0px'};
`;

export const ValueContainer = styled.div`
  margin: 20px;
  text-align: right;
`;

export const Value = styled.div`
  font-weight: normal;
  font-size: 11px;
  line-height: 15px;
  text-align: right;
  color: #2D8BFF;
`;

export const ValueDesc = styled.div`
  font-weight: normal;
  font-size: 11px;
  line-height: 15px;
  text-align: right;
  color: #939AAB;
`;

/* Social Report Overview Rows */
export const StyledContentTitle = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 17px;
  color: #343434;

  ${({ allowMultiline }) => !allowMultiline && css`
    ${textOverflow}
  `};
`;

export const StyledEntityTitle = styled.div`
  color: #2d8bff;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 15px;

  ${({ allowMultiline }) => !allowMultiline && css`
    ${textOverflow}
  `};
`;
